<!-- <h2>{{'recipe.ingredients' | translate}}</h2> -->
<div class="flex flex-row flex-wrap">
    @for (i of personsoptions; track $index) {
    <div [ngClass]="personquantity === i ? 'bg-e-dark-green text-white' : 'bg-white text-e-dark-green'" id="persons-{{i}}"
        class="chip mr-2.5 cursor-pointer hover:bg-e-dark-green hover:text-white transition-colors" (click)="personquantity = i">
        <span>{{doublepersons ? i * 2: i}} {{'common.person_abbr' | translate}}</span>
    </div>
    }
</div>

<ul class="flex flex-col list-disc ml-6 mb-6">

    @for (ingredient of ingredients; track i; let i = $index) {
    @if (!!ingredient.provided && ingredient.provided === true || ingredient.provided === undefined) {
    <li class="py-1">
        <strong>
            @if(getIngredientQuantity(ingredient) !== 0){<span id="ingredient-{{i}}">{{getIngredientQuantity(ingredient)}} </span>}
            {{'unit_abbr.' + ingredient.unit | translate | lowercase}} {{ingredient.displayname}}
        </strong>
        @if (ingredient.producer) {
        <small class="block"><i>{{'common.from_posessive'| translate}} <span class="text-capitalize">{{ingredient.producer}}</span></i></small>
        }
    </li>
    }
    }
</ul>

@if (hasAddYourself) {
<strong>{{'recipe.add_yourself' | translate}}</strong>
<ul class="list-disc ml-6">
    @for (ingredient of ingredients; track $index) {
    @if(!ingredient.provided){
    <li class="py-1">
        @if (getIngredientQuantity(ingredient)!== 0) { {{getIngredientQuantity(ingredient)}} }
        {{'unit_abbr.' + ingredient.unit | translate | lowercase}} {{ingredient.displayname}}
    </li>
    }
    }
</ul>
}